//Install
import React, { Component } from "react";
//Install
import { ReactComponent as O84VP6 } from "../../../../../Media/Brand/005.svg";

//Element
class Z512OJ extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "S0u16d C96Q4r vR05U6 d721Vx k738qv" },
            //Element
            React.createElement(O84VP6, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Z512OJ;